import { render, staticRenderFns } from "./RolesMultiselect.vue?vue&type=template&id=5b7b6b76&"
import script from "./RolesMultiselect.vue?vue&type=script&lang=js&"
export * from "./RolesMultiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports